var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{staticClass:"overlay",attrs:{"show":_vm.show}},[_c('div',{staticClass:"overPopup"},[_c('div',{staticClass:"overPopup-text"},[_vm._v(" 请确定微信支付是否支付完成 ")]),_c('div',{staticClass:"overPopup-yes",on:{"click":_vm.payyes}},[_vm._v(" 已完成支付 ")]),_c('div',{staticClass:"overPopup-not",on:{"click":_vm.payyes}},[_vm._v(" 暂未支付 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }